// UI-01 krok 3b (decyzja Miro 26.10, szyna 809/810): konto z flagą `ui_nowe` po zalogowaniu i na starych ścieżkach startowych
// (`/`, `/dashboard`) trafia do `/nowe`. Powrót: przycisk „Stary interfejs” w nowym UI zapamiętuje wybór w `sessionStorage`
// (`ui_wybor=stary`) — do zamknięcia karty; wejście na `/nowe` (link, adres) kasuje wybór. Konta bez flagi: bez wpływu
// (żadnego przekierowania, żadnego odczytu poza jednym `GET /flags` na kartę — tym samym, który i tak robi nowy UI).
// Montowane w App.js (jedna linia) — żadnych zmian w klasycznych widokach.
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { useFlagiUi, ustawUzytkownikaFlag } from "./flaga";

export const KLUCZ_WYBORU = "ui_wybor";
export const STARY = "stary";
/** Stare ścieżki startowe, z których konto z flagą jest kierowane do nowego UI. */
export const SCIEZKI_STARTOWE = ["/", "/dashboard"];
export const CEL = "/nowe";

export function czytajWybor() {
  try {
    return window.sessionStorage.getItem(KLUCZ_WYBORU);
  } catch {
    return null;
  }
}

export function ustawWybor(wartosc) {
  try {
    if (wartosc) window.sessionStorage.setItem(KLUCZ_WYBORU, wartosc);
    else window.sessionStorage.removeItem(KLUCZ_WYBORU);
  } catch {
    /* brak storage (tryb prywatny) = brak pamięci wyboru; przekierowanie i tak działa */
  }
}

/** Czysta reguła (testowalna bez React): przekierować tylko, gdy użytkownik zalogowany, ścieżka startowa, flaga JAWNIE true i brak wyboru „stary”. */
export function czyPrzekierowac({ pathname, zalogowany, flagi, wybor }) {
  if (!zalogowany) return false;
  if (!SCIEZKI_STARTOWE.includes(pathname)) return false;
  if (!flagi || !flagi.gotowe || flagi.uiNowe !== true) return false;
  if (wybor === STARY) return false;
  return true;
}

/** Montowany w App.js obok tras: `<Navigate>` do /nowe gdy reguła spełniona; na /nowe kasuje wybór „stary”. */
export default function PrzekierowanieDoNowego() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const naNowym = pathname.startsWith(CEL);
  const startowa = SCIEZKI_STARTOWE.includes(pathname);
  if (user?.id) ustawUzytkownikaFlag(user.id);
  useEffect(() => {
    if (naNowym) ustawWybor(null);
  }, [naNowym]);
  if (!user || !startowa) return null;
  return <Przekierowanie zalogowany pathname={pathname} />;
}

function Przekierowanie({ zalogowany, pathname }) {
  const flagi = useFlagiUi();
  if (!czyPrzekierowac({ pathname, zalogowany, flagi, wybor: czytajWybor() })) return null;
  return <Navigate to={CEL} replace />;
}

/** Przycisk w nagłówku nowego UI: zapamiętuje wybór „stary” (do zamknięcia karty) i przechodzi do klasyka. */
export function PrzyciskStaryInterfejs({ className = "" }) {
  const { t } = useTranslation("ui-nowe");
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={`przycisk cichy maly ${className}`.trim()}
      onClick={() => {
        ustawWybor(STARY);
        navigate("/dashboard");
      }}
      title={t("naglowek.staryInterfejsOpis")}
    >
      {t("naglowek.staryInterfejs")}
    </button>
  );
}
